import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PathwayMapping } from 'src/shared/models/pathway-mapping.model';
import { AuthService } from 'src/shared/services/auth.service';
import { PathwayMappingService } from 'src/shared/services/pathway-mapping.service';
import { RegistrationService } from 'src/shared/services/registration.service';
import { SetupService } from 'src/shared/services/setup.service';
import { TranslateService } from 'src/shared/services/translate.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-period-setup',
  templateUrl: './period-setup.component.html',
  styleUrl: './period-setup.component.scss'
})
export class PeriodSetupComponent {

  @ViewChild('addSetup', {static: true}) public modalAddSetup: NgbModalRef;
  @ViewChild('editSetup', {static: true}) public modalEditSetup: NgbModalRef;

  paramForm: FormGroup;
  newForm: FormGroup;
  editForm: FormGroup;

  detailData: any = null;
  data: any[] = [];
  columnsToDisplay = ['module_name', 'year-period', 'year_level','role', 'fullname'];
  sort = 'asc';
  orderBy = 'activity_name';
  subscription: Subscription;
  loading = false;
  searchParam: string;
  periodSelected: any;
  periodList: any;
  yearLevelRelations: any;
  yearLevelRelationsSelected: any[] = [];
  moduleList = ['School Program New Activity Approval', 'School Program Activity Participant Approval'];
  moduleSelected: any;
  setupList: any[] = [];
  invalidDate = false;

  constructor(
    private psSerice: SetupService,
    private pmService: PathwayMappingService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private registService: RegistrationService,
    public auth: AuthService
  ) { }

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    if (this.auth.permissions['SCHOOL_PROGRAM_PERIOD_SETUP_EDIT'] || this.auth.permissions['SCHOOL_PROGRAM_PERIOD_SETUP_DELETE']) {
      this.columnsToDisplay.push('action');
    }
    this.translate.load('extracurricular', 'activity');
    this.initForm();
    this.getPeriodList();
  }

  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'period_id': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'period_setup_id': new FormControl(null),
    });

    this.newForm = new FormGroup({
      'academic_year': new FormControl(null, Validators.required),
      'period_id': new FormControl(null, Validators.required),
      'school_location_id': new FormControl(null, Validators.required),
      'school_level_id': new FormControl(null, Validators.required),
      'year_level_id': new FormControl(null, Validators.required),
      'period_setup_id': new FormControl(null, Validators.required),
      'start_date': new FormControl(null, Validators.required),
      'start_time': new FormControl(null, Validators.required),
      'end_date': new FormControl(null, Validators.required),
      'end_time': new FormControl(null, Validators.required),
    });

    this.editForm = new FormGroup({
      'period_setup_setting_id': new FormControl(null, Validators.required),
      'period_setup_id': new FormControl(null, Validators.required),
      'start_date': new FormControl(null, Validators.required),
      'start_time': new FormControl(null, Validators.required),
      'end_date': new FormControl(null, Validators.required),
      'end_time': new FormControl(null, Validators.required),
    });

    this.getSetupList();
  }

  onChangeAcademicYear(item: any, option: any = null) {
    if (option === 'add') {
      this.newForm.controls['academic_year'].markAsTouched();
      this.newForm.controls['academic_year'].setValue(item ? item.academic_year : null);
  
      this.newForm.controls['school_location_id'].setValue(null);
      return;
    }

    this.paramForm.controls['academic_year'].markAsTouched();
    this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

    this.paramForm.controls['school_location_id'].setValue(null);
  }

  onChangePeriod(item: any, option: any = null) {

    if (option === 'add') {
      this.newForm.controls['period_id'].markAsTouched();
      this.newForm.controls['period_id'].setValue(item ? +item.period_id : null);

      return;
    }

    this.paramForm.controls['period_id'].markAsTouched();
    this.paramForm.controls['period_id'].setValue(item ? item.period_id : null);

    this.getPeriodSetting();
  }
  
  getPeriodList() {
    this.registService.getPeriodList().subscribe({
      next: (response: any) => {
        if (response.status) {
          this.periodList = response.data;
        } else {
          Swal.fire({
            title: 'Error',
            text: response.message,
            icon: 'error',
          });
        }
      },
      error: (error: any) => {
        Swal.fire({
          title: 'Error',
          text: 'An unexpected error occurred. Please check your connection and try again.',
          icon: 'error',
          confirmButtonText: 'Retry',
        });
      }
    });
  }

  onChangeSchoolLevel(item: any, option: any = null) {

    if (option === 'add') {
      this.newForm.controls['school_location_id'].markAsTouched();
      this.newForm.controls['school_location_id'].setValue(item ? +item.school_location_id : null);
  
      this.newForm.controls['school_level_id'].markAsTouched();
      this.newForm.controls['school_level_id'].setValue(item ? +item.school_level_id : null);

      this.yearLevelRelations = [];
      if (item) {
        this.getNewPathwayMapping(option);
      }
      return;
    }

    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    if (item) {
      this.getPeriodSetting();
    }
  }

  getNewPathwayMapping(option: any = null) {

    let params = {};
    if (option === 'add') {
      params = {
        academic_year: this.newForm.controls['academic_year'].value,
        school_location_id: this.newForm.controls['school_location_id'].value,
        school_level_id: this.newForm.controls['school_level_id'].value,
      }
    } else {
      params = {
        academic_year: this.paramForm.controls['academic_year'].value,
        school_location_id: this.paramForm.controls['school_location_id'].value,
        school_level_id: this.paramForm.controls['school_level_id'].value,
      }
    }
    this.pmService.yearLevelNoAcademic(params)
      .subscribe((response: PathwayMapping) => {
        // @ts-ignore
        if (response.status) {
          // @ts-ignore
          this.yearLevelRelations = response.data.slice();
          // this.yearLevelRelations.forEach((element: { selected: boolean; }) => {
          //   element.selected = false;
          // });
        } else {
          // @ts-ignore
        }
      }, (error: any) => {
      });
  }
  
  onChangeYearLevelByCheckbox(event: any, item: any) {
    if (event.checked) {
      this.yearLevelRelationsSelected.push(+item.year_level_id);
    } else {
      this.yearLevelRelationsSelected.splice(this.yearLevelRelationsSelected.indexOf(+item.year_level_id), 1);
    }
    this.insertYearLevel();
  }

  insertYearLevel() {
    this.newForm.controls['year_level_id'].markAsTouched();
    this.newForm.controls['year_level_id'].setValue(null);
    this.newForm.controls['year_level_id'].setValue(this.yearLevelRelationsSelected.length > 0 ? this.yearLevelRelationsSelected : null);
  }


  onChangeModule(item: any, option: any = null) {

    if (option === 'add') {
      this.newForm.controls['period_setup_id'].markAsTouched();
      this.newForm.controls['period_setup_id'].setValue(item ? item.period_setup_id : null);
  
      return;
    }

    this.paramForm.controls['period_setup_id'].markAsTouched();
    this.paramForm.controls['period_setup_id'].setValue(item ? item.period_setup_id : null);

    this.getPeriodSetting();
  }

  changePeriodSetupSettingDate(option: any = null) {
    if (option === 'add' && this.newForm.get('start_date')?.value && this.newForm.get('end_date')?.value) {
      this.invalidDate = this.newForm.get('start_date')?.value > this.newForm.get('end_date')?.value;
    } else if (this.editForm.get('start_date')?.value && this.editForm.get('end_date')?.value) {
      this.invalidDate = this.editForm.get('start_date')?.value > this.editForm.get('end_date')?.value;
    }
  }

  getSetupList() {
    this.psSerice.getPeriodSetup({}).subscribe((response: any) => {
      if (response.status) {
        this.setupList = response.data;
      } else {
        Swal.fire({
          title: 'Error',
          text: response.message,
          icon: 'error',
        });
      }
    }, (error: any) => {
      Swal.fire({
        title: 'Error',
        text: 'An unexpected error occurred. Please check your connection and try again.',
        icon: 'error',
        confirmButtonText: 'Retry',
      });
    });
  }

  getPeriodSetting() {
    this.loading= true;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.data = [];
    const params = {
      academic_year: this.paramForm.get('academic_year')?.value,
      school_location_id: this.paramForm.get('school_location_id')?.value,
      school_level_id: this.paramForm.get('school_level_id')?.value,
      module_name: this.paramForm.get('module_name')?.value,
      period_id: this.paramForm.get('period_id')?.value
    }
    this.subscription = this.psSerice.getPeriodSetupSetting(params).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.data = response.data;
          this.loading = false;
        } else {
          Swal.fire({
            title: 'Error',
            text: response.message,
            icon: 'error',
          });
          this.loading = false;
        }
      },
      error: (error: any) => {
        Swal.fire({
          title: 'Error',
          text: 'An unexpected error occurred. Please check your connection and try again.',
          icon: 'error',
          confirmButtonText: 'Retry',
        });
        this.loading = false;
      }
    });
  }

  openModalAdd (id: any = null) {
    this.translate.load('extracurricular', 'activity');
    this.modalService.open(this.modalAddSetup, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      backdrop : 'static',
      size: 'lg'
    }).result.then((result: any) => {

    }, (reason: any) => {

    });
  }

  openModalEdit (id: number) {
    if (id) {
      this.getSetupDetail(id);
    }
    this.translate.load('extracurricular', 'activity');
    this.modalService.open(this.modalEditSetup, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      backdrop : 'static',
      size: 'lg'
    }).result.then((result: any) => {

    }, (reason: any) => {

    });
  }

  getSetupDetail(id: number) {
    this.psSerice.getPeriodSetupSetting({period_setup_setting_id: +id}).subscribe((response: any) => {
      if (response.status) {
        this.detailData = response.data[0];
        this.patchData(this.detailData);
      } else {
        Swal.fire({
          title: 'Error',
          text: response.message,
          icon: 'error',
        });
      }
    }, (error: any) => {
      Swal.fire({
        title: 'Error',
        text: 'An unexpected error occurred. Please check your connection and try again.',
        icon: 'error',
        confirmButtonText: 'Retry',
      });
    });
  }

  patchData(data: any): void {
    this.editForm.patchValue({
      period_setup_setting_id: data.period_setup_setting_id,
      period_setup_id: data.period_setup_id,
    });

    const startDate = new Date(data.start_date);
    const endDate = new Date(data.end_date);
    const toLocalDateString = (date: Date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

    const startDateString = toLocalDateString(startDate);
    const startTimeString = startDate.toTimeString().split(' ')[0];

    const endDateString = toLocalDateString(endDate);
    const endTimeString = endDate.toTimeString().split(' ')[0];

    this.editForm.patchValue({
      start_date: startDateString,
      start_time: startTimeString,
      end_date: endDateString,
      end_time: endTimeString,
    });
  }

  onCloseModal() {
    this.yearLevelRelationsSelected = [];
    this.modalService.dismissAll(this.modalAddSetup);
    this.newForm.reset();
    this.editForm.reset();
    this.detailData = null;
  }

  onAdd() {
    this.psSerice.createPeriodSetupSetting(this.newForm.value).subscribe({
      next: (response: any) => {
        if(response.status){
          Swal.fire({
            title: "Success",
            text: "Period setup has been created.",
            icon: "success"
          });
          this.onCloseModal();
          this.getPeriodSetting();
        } else {
          Swal.fire({
            title: "Error",
            text: response.message,
            icon: "error"
          });
        }
      },
      error: (error: any) => {
        Swal.fire({
          title: "Error",
          text: "An unexpected error occurred. Please check your connection and try again.",
          icon: "error",
          confirmButtonText: "Retry"
        });
      }
    });
  }

  onEdit() {
    this.psSerice.updatePeriodSetupSetting(this.editForm.value).subscribe({
      next: (response: any) => {
        if(response.status){
          Swal.fire({
            title: "Success",
            text: "Period setup has been updated.",
            icon: "success"
          });
          this.onCloseModal();
          this.getPeriodSetting();
        } else {
          Swal.fire({
            title: "Error",
            text: response.message,
            icon: "error"
          });
        }
      },
      error: (error: any) => {
        Swal.fire({
          title: "Error",
          text: "An unexpected error occurred. Please check your connection and try again.",
          icon: "error",
          confirmButtonText: "Retry"
        });
      }
    });
  }

  onDelete(period_setup_setting_id: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.psSerice.deletePeriodSetupSetting(period_setup_setting_id).subscribe({
          next: (response: any) => {
            if(response.status){
              Swal.fire({
                title: "Success",
                text: "Period setup has been deleted.",
                icon: "success"
              });
              this.getPeriodSetting();
            } else {
              Swal.fire({
                title: "Error",
                text: response.message,
                icon: "error"
              });
            }
          },
          error: (error: any) => {
            Swal.fire({
              title: "Error",
              text: "An unexpected error occurred. Please check your connection and try again.",
              icon: "error",
              confirmButtonText: "Retry"
            });
          }
        });
      }
    });
  }

}
